import { ProductTranslations } from '../interfaces/product';

const EnglishProductTranslations: ProductTranslations = {
  description: 'Description',
  attributes: {
    label: {
      link: 'Link:',
      quantity: 'Quantity:',
      comment: 'Add a comment:',
    },
    placeholder: {
      comment: 'Type a comment, then press ENTER',
    },
  },
  buttons: {
    addToCart: 'Add to cart',
    addComment: 'Add',
    more: 'More...',
    less: 'Less',
  },
};

export default EnglishProductTranslations;
